import * as types from 'actions';

export const initialState={
  requestId: '',
  id: '',
  fullname: '',
  age: undefined,
  gender: 'male',
  bloodGroup: 'O+',
  units: undefined,
  requiredBy: '',
  purpose: '',
  hospitalName: '',
  hospital: '',
  attender: '',
  email: '',
  phone: '',
  district: '',
  pincode: '',
  stateLocation: '',
  country: '',
  status: '',
  matchingDonors: undefined,
  matchDonorPhone: undefined,
  saveMatchingDonorResponse: 'undefined',
  matchingDonorsDetails: [],
  actualDonors: [],
  auditTrail: [],
  systemRemarks: '',
  noServiceResponse: false,
  locality: '',
  action: '',
  feedback: '',
  lastModifiedBy: '',
  lastModifiedAt: '',
  notes: ''
};

export default function(state = initialState, action) {
  let response = '';
  let allPatientRequests = '';
  switch(action.type) {
    case types.PATIENT_SUBMIT_SUCCESS:
      response = action.response;
      return { 
        ...state,
        action: action.type,
        fullname: response.fullname,
        age: response.age,
        gender: response.gender,
        bloodGroup: response.bloodGroup,
        units: response.units,
        requiredBy: response.requiredBy,
        purpose: response.purpose,        
        hospitalName: response.hospitalName,
        hospital: response.hospital,
        attender: response.attender,
        email: response.email,
        phone: response.phone,
        district: response.district,
        pincode: response.pincode,
        stateLocation: response.stateLocation,
        status: response.status,
        country: response.country,
        volunteerDonors : response.volunteerDonors,
        actualDonors : response.actualDonors,
        auditTrail : response.auditTrail,
        systemRemarks: 'Sairam! Updated successfully',
        noUpdateServiceResponse: false,
        locality: response.locality,
        feedback: response.feedback,
        notes: response.notes,
        lastModifiedBy: response.modifiedBy,
        lastModifiedAt: response.modifiedTimestamp,
        response
       };
    case types.PATIENT_SUBMIT_ERROR:
      response = action.response;
      return { 
        ...state, 
        noServiceResponse: true,
        response };
    case types.PATIENT_UPDATE_SUCCESS:
      response = action.response;
      return { 
        ...state,
        action: action.type, 
        id: response.id,
        fullname: response.fullname,
        age: response.age,
        gender: response.gender,
        bloodGroup: response.bloodGroup,
        units: response.units,
        requiredBy: response.requiredBy,
        purpose: response.purpose,
        hospitalName: response.hospitalName,        
        hospital: response.hospital,
        attender: response.attender,
        email: response.email,
        phone: response.phone,
        district: response.district,
        pincode: response.pincode,
        stateLocation: response.stateLocation,
        status: response.status,
        country: response.country,
        volunteerDonors : response.volunteerDonors,
        actualDonors : response.actualDonors,
        auditTrail : response.auditTrail,
        systemRemarks: response.systemRemarks ? response.systemRemarks : 'Sairam! Updated successfully',
        noUpdateServiceResponse: false,
        locality: response.locality,
        feedback: response.feedback,
        notes: response.notes,
        lastModifiedBy: response.modifiedBy,
        lastModifiedAt: response.modifiedTimestamp,
        response   
       };
    case types.PATIENT_UPDATE_ERROR:
      response = action.response;
      return { 
        ...state, 
        noUpdateServiceResponse: true,
        response };
    case types.ALL_PATIENT_FETCH_SUCCESS:
      allPatientRequests = action.response;
      return { 
        ...state, 
        noServiceResponse: false,
        allPatientRequests };
    case types.ALL_PATIENT_FETCH_ERROR:
      response = action.response;
      return { 
        ...state, 
        noServiceResponse: true,
        allPatientRequests };
    case types.FETCH_BY_PATIENT_NAME_SUCCESS:
      allPatientRequests = action.response;
      return { 
        ...state, 
        noServiceResponse: false,
        allPatientRequests };
    case types.FETCH_BY_PATIENT_NAME_ERROR:
      response = action.response;
      return { 
        ...state, 
        noServiceResponse: true,
        allPatientRequests };    
    case types.FETCH_BY_ATTENDER_NAME_SUCCESS:
          allPatientRequests = action.response;
          return { 
            ...state, 
            noServiceResponse: false,
            allPatientRequests };
    case types.FETCH_BY_ATTENDER_NAME_ERROR:
          response = action.response;
          return { 
            ...state, 
            noServiceResponse: true,
            allPatientRequests };        
    case types.FETCH_BY_PATIENT_PHONE_SUCCESS:
              allPatientRequests = action.response;
              return { 
                ...state, 
                noServiceResponse: false,
                allPatientRequests };
    case types.FETCH_BY_PATIENT_PHONE_ERROR:
              response = action.response;
              return { 
                ...state, 
                noServiceResponse: true,
                allPatientRequests };            
    case types.PATIENT_FETCH:      
      response = action.response;
      return {
        ...state,
        requestId: action.patient
      }        
    case types.PATIENT_FETCH_SUCCESS:
      response = action.response;      
      return { 
        ...state,
        action: action.type,
        id: response.id,
        fullname: response.fullname,
        age: response.age,
        gender: response.gender,
        bloodGroup: response.bloodGroup,
        units: response.units,
        requiredBy: response.requiredBy,
        purpose: response.purpose,
        hospitalName: response.hospitalName,        
        hospital: response.hospital,
        attender: response.attender,
        email: response.email,
        phone: response.phone,
        district: response.district,
        pincode: response.pincode,
        stateLocation: response.stateLocation,
        status: response.status,
        country: response.country,
        volunteerDonors : response.volunteerDonors,
        actualDonors : response.actualDonors,
        auditTrail : response.auditTrail,
        noServiceResponse: false,
        locality: response.locality,
        feedback: response.feedback,
        notes: response.notes,
        lastModifiedBy: response.modifiedBy,
        lastModifiedAt: response.modifiedTimestamp,
        response
      };
    case types.PATIENT_FETCH_ERROR:
      response = action.response;
      return { 
        ...state, 
        noServiceResponse: true,
        response };    
    case types.PATIENT_VERIFY_SUCCESS:      
      response = action.response;
      return { 
        ...state,
        action: action.type,
        id: response.id,
        fullname: response.fullname,
        age: response.age,
        gender: response.gender,
        bloodGroup: response.bloodGroup,
        units: response.units,
        requiredBy: response.requiredBy,
        purpose: response.purpose,
        hospitalName: response.hospitalName,        
        hospital: response.hospital,
        attender: response.attender,
        email: response.email,
        phone: response.phone,
        district: response.district,
        pincode: response.pincode,
        stateLocation: response.stateLocation,
        status: response.status,
        country: response.country,
        volunteerDonors : response.volunteerDonors,
        actualDonors : response.actualDonors,
        auditTrail : response.auditTrail,
        noServiceResponse: false,
        locality: response.locality,
        feedback: response.feedback,
        notes: response.notes,
        lastModifiedBy: response.modifiedBy,
        lastModifiedAt: response.modifiedTimestamp,
        response
      }
    case types.PATIENT_VERIFY_ERROR:
      response = action.response;
      return { 
        ...state, 
        noServiceResponse: true,
        response };
    case types.MATCH_DONORS_SUCCESS:      
      response = action.response;  
      return { 
          ...state,
          action: action.type,
          id: response.id,
          fullname: response.fullname,
          age: response.age,
          gender: response.gender,
          bloodGroup: response.bloodGroup,
          units: response.units,
          requiredBy: response.requiredBy,
          purpose: response.purpose,
          hospitalName: response.hospitalName,
          hospital: response.hospital,
          attender: response.attender,
          email: response.email,
          phone: response.phone,
          district: response.district,
          pincode: response.pincode,
          stateLocation: response.stateLocation,
          status: response.status,
          country: response.country,
          volunteerDonors : response.volunteerDonors,
          actualDonors : response.actualDonors,
          auditTrail : response.auditTrail,
          matchingDonors : response.matchingDonors,
          matchingDonorsDetails : response.matchingDonorsDetails,
          locality: response.locality,
          feedback: response.feedback,
          notes: response.notes,
          lastModifiedBy: response.modifiedBy,
          lastModifiedAt: response.modifiedTimestamp,  
          noServiceResponse: false
        }
    case types.MATCH_DONORS_ERROR:
      response = action.response;    
      return { 
        ...state, 
        noServiceResponse: true,
        response };
    case types.SAVE_MATCHING_DONOR_SUCCESS:
      response = action.response;      
      return { 
        ...state, 
        saveMatchingDonorResponse : response,
        noServiceResponse: false,
        systemRemarks: 'Sairam! Saved notes successfully' };
    case types.SAVE_MATCHING_DONOR_ERROR:
      response = action.response;    
      return { 
        ...state, 
        noServiceResponse: true,
        response };
      case types.MATCH_DONOR_PHONE_SUCCESS:
        response = action.response;      
        return { 
          ...state, 
          matchDonorPhone : response,
          noServiceResponse: false,
          systemRemarks: 'Sairam! Matching donor fetched successfully' };
      case types.MATCH_DONOR_PHONE_ERROR:
        response = action.response;    
        return { 
          ...state, 
          noServiceResponse: true,
          response };                  
    default:
      return state;
  }
};